// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.QuickBook = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.QuickBook = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var QuickBook = _exports.QuickBook = function QuickBook(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14268)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.41076 9.9966C2.41156 12.2574 4.23476 14.0958 6.49556 14.1158H7.07396V12.6046H6.49556C5.09396 12.987 3.64836 12.1606 3.26676 10.759C3.26356 10.7478 3.26116 10.7366 3.25796 10.7254C2.86516 9.3054 3.68756 7.8342 5.10276 7.4254H5.39156C5.75396 7.3462 6.12916 7.3462 6.49156 7.4254H7.89636V15.4486C7.88916 16.2974 8.57156 16.9918 9.42036 16.9998V5.8366H6.50436C4.22756 5.8486 2.39236 7.7038 2.40436 9.9806V9.9814L2.41076 9.9966ZM13.5108 5.8382H12.9324V7.4294H13.5108C14.9092 7.0478 16.3516 7.8718 16.7332 9.2694C16.7364 9.2798 16.7388 9.291 16.742 9.3014C17.1324 10.7166 16.3124 12.1822 14.9028 12.5902H14.614C14.2516 12.6694 13.8764 12.6694 13.514 12.5902H12.1092V4.5678C12.1164 3.719 11.434 3.0246 10.5852 3.0166V14.1958H13.5012C15.798 14.1598 17.6308 12.2694 17.5956 9.9726C17.5604 7.7262 15.7484 5.9134 13.5012 5.8782L13.5108 5.8382Z",
      fill: "white"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14268"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
